import { Route, Navigate, Outlet } from 'react-router-dom'
import { FaroRoutes } from '@grafana/faro-react'
import AllocationProvider from './AllocationProvider'
import { ExpertReviewRoutes } from './expert-review/navigation/ExpertReviewRoutes'
import { AllocationPlansRoutes } from './plans-v4/routes/AllocationPlansRoutes'
import { RebalanceQuestionnaireRoutes } from './rebalance-questionnaire/RebalanceQuestionnaireRoutes'
import { RetryRoute } from '../../Routes/RetryRoute'

export const AllocationRoutes = () => {
  return (
    <AllocationProvider>
      <FaroRoutes>
        <Route path="/allocation" element={<Outlet />}>
          <Route index element={<Navigate to="/allocation/expert-review" replace />} />
        </Route>
        {...ExpertReviewRoutes()}
        {...AllocationPlansRoutes()}
        {...RebalanceQuestionnaireRoutes()}
        <Route path="*" element={<RetryRoute />} />
      </FaroRoutes>
    </AllocationProvider>
  )
}
